export const CapFirst = (cadena) => {
    if(cadena === null || cadena === undefined){
        return "";
    }else{
        let firstUp = cadena.charAt(0);
        return  `${firstUp.toUpperCase()}${cadena.substring(1)}`        
    }    
}